import { whileInUse, whileVisible } from 'shared/query/attention';

/**
 * How often an open approval is read again: every 30 s while it waits for a person's
 * decision, which can take hours, and every 5 s while its approved effect runs, which
 * someone may watch without touching anything. Use with refetchIntervalInBackground.
 */
export const approvalRefetchInterval = (query) => {
  const approval = query.state.data?.approval;
  if (approval?.execution_state === 'running') return whileVisible(5000);
  if (approval?.status === 'pending') return whileInUse(30000);
  return approval?.execution_state === 'pending' ? whileVisible(5000) : false;
};
